import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=b6afbd0e&"
import script from "./FooterButton.vue?vue&type=script&lang=ts&"
export * from "./FooterButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports